import { render, staticRenderFns } from "./AutocompleteSectionBlock.vue?vue&type=template&id=1d07b34f&scoped=true&"
import script from "./AutocompleteSectionBlock.vue?vue&type=script&lang=ts&"
export * from "./AutocompleteSectionBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AutocompleteSectionBlock.vue?vue&type=style&index=0&id=1d07b34f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d07b34f",
  null
  
)

export default component.exports